import {fetch_data, game, user, view} from "./client.svelte.js";
import {mapElement} from "./play/Encounter.svelte"

/*** Pentelion general data  ***/
export let protoTraits = []     // all traits (primaries and secondaries)
export let protoSkills = {}     // all standard skills (can be extended by secondary skills of individual characters)
export let protoDomains = {}	// all domains
export let protoActions = {}	// all Actions, Skills and Powers in Pentelion
export let protoEffects = {}	// all prototype effects
export let protoWeapons = {}	// all basic weapons
export let protoArmor = {}      // all basic armor
export let protoShopitems = []  // all items offered by merchants (shopitems in pentelion.db)

export let levelBoundaries = []          // boundaries for levels
export let whatsnew = {}
export let docs = []

export const categories = {
	G: "Allg.", GP: "Körperliche", GI: "Geistige", GS: "Soziale",  GN: "Natur", GU: "Stadt", GK: "Wissen", GH: "Handwerk", G_: "Neben",
    C: "Kampf", C_: "Kampffertigk", CS: "Kampfstile", CR: "Rollen", CW: "Waffen",
    M: "Magie", M_: "Magierfertigk.", MS: "Zauberstile", MA: "Astralmagie", ME: "Elementarmagie", MM: "Mentalmagie", MV: "Vitalmagie",
	B: "Biest",}
export const Incepts = ['Insight', 'Incept']
export const Implics = ['Implication', 'Inmotion', 'Induce', 'Incur', 'Inflict', 'Intensify', 'Indirect', 'Ingress']

export async function init_core() {
	console.log("CORE-init: fetching core data (async)");
	const response = await fetch("/core");
	const data = await response.json();
	console.log(`  – Core data received `, data);
	/* initialize all fixed core data */
	( { traits: protoTraits, skills: protoSkills, domains: protoDomains, actions: protoActions, effects: protoEffects,
		weapons: protoWeapons, armors: protoArmor, shopitems: protoShopitems, levels: levelBoundaries, whatsnew } = data);
	// globalThis.protoActions = protoActions
	/* enrich action data with colors */
	for (let actionData of Object.values(protoActions)) {
        const hue = (actionData.kind) ? impactHue[actionData.kind] : 210
        let sat = 100, lum = 50
        if (actionData.tier > 0) { // is power a fight-only power?
            lum = Math.round(85 - actionData.exertion * 1.5)
            sat = Math.round(70 + Math.min(Math.abs(55 - lum), 30))
        } else if (!(actionData.kind)) sat = 0
        actionData['cardColor'] = `hsl(${hue},${sat}%,${lum}%)`
        actionData['activityColor'] = `hsl(${hue},${sat}%,${Math.round(lum / 3)}%)`
	}
	return data
}

export async function fetch_documentation(){
	const rawdocs = await fetch_data("/documentation")
	docs = rawdocs.map(entry => Object.assign(entry, {TYPE: 'doc'}))
	// docs = Object.fromEntries(docsList.map(entry => [entry.topic, entry]))
	// globalThis.docs = docs
	console.log(`CORE - documentation fetched`, docs)
	return docs
}

/** merges newly re-read documentation entries into `docs`, first dropping the entries of the
 *  chapter/section/topic that `part` (as used by the "/readdocs/<part>" route) has just replaced */
export function merge_documentation(newEntries, part) {
	const fields = ['chapter', 'section', 'topic']
	if (part && part !== "_") {
		const wanted = Object.fromEntries(fields.map((field, i) => [field, part.split("-")[i]]).filter(([, val]) => val !== undefined))
		docs = docs.filter(entry => !fields.filter(field => field in wanted).every(field => entry[field] === wanted[field]))
	} else
		docs = []
	docs = docs.concat(newEntries.map(entry => Object.assign(entry, {TYPE: 'doc'})))
	console.log(`CORE - documentation merged for part '${part ?? "_"}': ${newEntries.length} entries`, docs)
	return docs
}

/*** captures location (col,row,map) and provide conversion functions */
export class Location {
	static basemap = null

	constructor({col, row, map}, fgt = null) {
        this.col = Math.round(col * 10) / 10
        this.row = Math.round(row * 10) / 10
        this.map = map ?? view.map?.ID
        this.fgt = fgt
	}
	static from_array(posArray) {
		return new Location({col: posArray[0], row: posArray[1], map: posArray[2]})
	}
	static from_event(event, map = null) {
        let x = event.offsetX, y = event.offsetY, fgt
        if (event.type === 'touchstart') {
            const bcr = event.target.getBoundingClientRect();
            x = (event.targetTouches[0].clientX - bcr.x);
            y = (event.targetTouches[0].clientY - bcr.y);
        }
        if (event.target && event.target.id !== "map") {
            x += event.target.offsetLeft
            y += event.target.offsetTop
            fgt = (event.target.classList.contains('areaEffect')) ? null : event.target.dataset.char ?? null
        } else if (!(event instanceof DragEvent)) {	// this branch captures if target is not set to mapImg but to underlying element
            x += mapElement._positioningEl.offsetLeft - mapElement.x
            y += mapElement._positioningEl.offsetTop - mapElement.y
            fgt = null
        }
        return new Location({col: x / fieldResolution, row: y / fieldResolution, map: map}, fgt)
	}
	static from_text(posTxt) {
        if (posTxt.includes("/")) {
            const inner = posTxt.replace(/\(|\)/g, '')
            let [col, row] = inner.split("/")
            return new Location({col: parseFloat(col), row: parseFloat(row)})
        } else if (posTxt in Fighters)
            return Fighters[posTxt].position
        else
            return null
	}
	static from_loc(fromLoc) {
        return new Location({col: fromLoc.col, row: fromLoc.row, map: fromLoc.map}, fromLoc.fgt)
	}
	update(event, scale = fieldResolution) {
        let x = event.offsetX, y = event.offsetY, fgt
        if (event.type === 'touchstart') {
            const bcr = event.target.getBoundingClientRect();
            x = (event.targetTouches[0].clientX - bcr.x) / (mapElement?.scale ?? 1)
            y = (event.targetTouches[0].clientY - bcr.y) / (mapElement?.scale ?? 1)
            this.screenCoord = {x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY}
        } else
            this.screenCoord = {x: event.clientX, y: event.clientY}
        if (event.target && event.target.id !== "map") {
            x += event.target.offsetLeft
            y += event.target.offsetTop
            this.fgt = (event.target.classList.contains('areaEffect')) ? null : event.target.dataset.char ?? null
        } else {	// this branch captures if target is not set to mapImg but to underlying element
            x += map._positioningEl.offsetLeft - map.x
            y += map._positioningEl.offsetTop - map.y
            this.fgt = null
        }
        this.col = x / fieldResolution
        this.row = y / fieldResolution
		this.map = view.map.ID
	}
	toStr() {
        const col = Math.round(this.col * 10) / 10,  row = Math.round(this.row * 10) / 10
        const colInt = Math.trunc(col), colFirstDec = Math.round((col - colInt) * 10)
        const rowInt = Math.trunc(row), rowFirstDec = Math.round((row - rowInt) * 10)
        const mapStr = (game.maps.size > 1) ? `_${this.map}` : ""
        return `(${colInt}${String.fromCharCode(8320+colFirstDec)} ${rowInt}${String.fromCharCode(8320+rowFirstDec)})${mapStr}`
	}
	toString() {
        const charTxt = (this.fgt) ? `${this.fgt} | ` : ""  // Old: (view.perspective) ? `${view.perspective} | ` : ""
        return `${charTxt} ${this.toStr()}`
	}
	to_coord() { return {x: this.col * fieldResolution, y: this.row * fieldResolution } }
	toTokenCoord(size = 1) { return {x: (this.col - size / 2) * fieldResolution, y: (this.row - size / 2) * fieldResolution} }

	distance(otherLoc) { return Math.sqrt((this.col - otherLoc.col) ** 2 + (this.row - otherLoc.row) ** 2) }
}

export const executionTxt = {active: "aktiv", proactive: "initiativ", reactive: "reaktiv", progressive: "progressiv", ultimative: "ultimativ", passive: "passiv"}

export function is_in_timeline(info) {
	if (!info.flags)  console.log(`CORE - no flags in `, $state.snapshot(info))
    const isMuted = ('MUTED' in info.flags)   // is the incident muted
	const isTarget = (game.heroes.includes(info.target))    // is either directly the target or affected by this incident
					 // Old: (info.effects.filter(eff => eff.affected).reduce((bool, eff) => bool || (game.heroes.has(eff.affected)), false))
    const forPlayer = !('PRIVATE' in info.flags) || user.isMaster || (game.playables.includes(info.subject)) || isTarget
    const isDetected = user.isMaster || view.persona.detecteds.includes(info.subject)
    return (!isMuted && forPlayer && isDetected)
}

// check if given incident is observed by the passed playable persons (all incidents to and by fellows can be observed)
export function is_observed(incident, playables) {
	let observables = new Set(Array.from(game.personas.values()).filter(pers => pers.affil === 'fellow').map(pers => pers.ID))
	// add all fighters detected by any of the playables
	for (const persID of playables) {
		const pers = game.personas.get(persID)
		if (pers.detecteds.length > 0)
			observables = observables.union(new Set(pers.detecteds))
	}
	return observables.has(incident.subject) || observables.has(incident.target)
}

export function are_enemies(actor, other) {
	const actorData = game.personas.get(actor)
	const otherData = game.personas.get(other)
	if (!actorData || !otherData) return false
	return (actorData.affil[0] !== otherData.affil[0] && (actorData.affil !== 'neutral' || otherData.affil !== 'neutral'))
}

export function are_opponents(actor, other) {
	const actorData = game.personas.get(actor)
	const otherData = game.personas.get(other)
	if (!actorData || !otherData) return false
	return (actorData.affil[0] !== otherData.affil[0] && (actorData.affil !== 'neutral' || otherData.affil !== 'neutral'))
            && (actorData.controlleds.includes(other) || otherData.controlleds.includes(actor))
}

export function are_comrades(actor, other) {
	const actorData = game.personas.get(actor)
	const otherData = game.personas.get(other)
	if (!actorData || !otherData) return false
	return actorData.affil[0] === otherData.affil[0]
}

export function is_conform(aiming, actor, target) {
	return (!aiming.select || aiming.select === 'all' || aiming.select === 'pers' ||
            ((aiming.select === 'opp' && are_opponents(actor, target)) ||
             (aiming.select === 'enm' && are_enemies(actor, target)) ||
             (aiming.select === 'com' && are_comrades(actor, target)) ||
             (aiming.select === 'loc' && target)) )
}

export function is_allowed(action, affects) {
	const affKlasses = affects.map(afflID => game.effects.get(afflID)?.classname)
	if (affKlasses.includes('Swimming'))  return action === "schwimmen"
	if (affKlasses.includes('Climbing'))  return action === "klettern"
	return !(((action === "schleichen" || action === "huschen") && !affKlasses.includes('Hidden')) ||
             ((action === "gehen" || action === "laufen") && affKlasses.includes('Hidden')) ||
             (action === "schwimmen" || action === "klettern"))
}



class Character {
	skills = {}

	get KG() { return this.skills['cmb'] ?? null}
}

export function define_properties(character) {
	if (character.TYPE.slice(0,9) !== 'Character')  return
	// determine category for lists
	character['cat'] = (!character.owner || character.rubric === 'PUBLIC') ? 'publ' :
					   (character.rubric === 'HERO' || character.rubric === 'PART') ? character.rubric.toLowerCase() : 'priv'
	// add properties
	// if (!character.skills)  character['skills'] = {}
    // Object.defineProperty(character, 'cmb', {
    //     get: function () {
    //         return character.skills?.cmb ?? null
    //     }
    // })
    // Object.defineProperty(character, 'rng', {
    //     get: function () {
    //         return character.skills?.Schussgeschick ?? null
    //     }
    // })
    // Object.defineProperty(character, 'mag', {
    //     get: function () {
    //         const attribs = new Set(['Magiegeschick', 'Arcane Magie', 'Elementarmagie', 'Vitalmagie', 'Mentalmagie'])
    //         const attr = attribs.intersection(new Set(Object.keys(character.skills))).values()[0]
    //         return (attr) ? character.skills[attr] : null
    //     }
    // })
    // Object.defineProperty(character, 'vital', {
    //     get: function () {
    //         return Math.round(25 + (character.traits?.['build']?.value ?? 0) + (character.skills?.['Konstitution'] ?? 0)  + (character.domains?.['standhaft'] ?? 0) / 2 )
    //     }
    // })
}



/*** General functions ***/

export function isEmpty(obj) {
	return !obj || (obj instanceof Object && Object.keys(obj).length === 0) || (obj instanceof Array && obj.length === 0)
}
export function notEmpty(obj) {
	return !isEmpty(obj)
}

export function update_obj(obj, update) {
	Object.entries(update).forEach(([attr,value]) => obj[attr] = value)
}

export function timestamp(time) {
	if (time >= openEnd - 1)
		return "∞"
	if (game.mode === 'story')
		return String(time).padStart(3, "0")
	let min = Math.floor(time/60)
	let sec = (time % 60).toString().padStart(2, '0')
	return `${min}:${sec}`
}

/** up to two capital initials of a name (e.g. for avatars) **/
export const initials = (name) => (name ?? "").split(/\s+/).filter(Boolean).map(word => word[0]).join("").slice(0, 2).toUpperCase()

export const exhibit_URL = (exhibit, full = false ) => (exhibit) ?
	(full) ? `assets/${exhibit.owner}/exhibits/${exhibit.ID}.${exhibit.media}` :
			 `assets/${exhibit.owner}/.thumbnails/${exhibit.ID}.jpg` : null
export const mapimg_URL = (map, full = false ) => (map) ?
	(full) ? `assets/${map.owner}/maps/${(map.TYPE === 'Site') ? map.layers[map.main] : map.ID}.webp` :
			 `assets/${map.owner}/.thumbnails/${(map.TYPE === 'Site') ? map.layers[map.main] : map.ID}.jpg` : null
export const site_URL = (site, full = false) => (site) ?
	(full) ?
		(site.cover) ? `assets/${site.owner}/exhibits/${site.cover}.webp` : `assets/${site.owner}/maps/${site.ID}_${site.main ?? ""}.webp` :
		(site.cover) ? `assets/${site.owner}/.thumbnails/${site.cover}.jpg` : `assets/${site.owner}/.thumbnails/${site.ID}_${site.main ?? ""}.jpg`
	: null


export const image_URL = (exhibit, full = false ) => (filepath) ? (full) ? filepath :
	`${filepath.replace("images", "images\\.thumbnails").split(".").slice(0, -1).join(".")}.jpg` : null
export const filepath_URL = (filepath, full = false) => (filepath) ? (typeof filepath === 'object') ? `${filepath.folder}/${filepath.stem}.${(full) ? filepath.suffix : "thumb"}` : filepath : null

//*** acustic feedback
export const longDiceAudio = new Audio("../static/sounds/rolling_dice.wav")
export const shortDiceAudio = new Audio("../static/sounds/thrown_dice.mp3")
export const tickerAudio = new Audio("../static/sounds/tickerSound.mp3")
tickerAudio.volume = 0.3

export const successText = {'Pa': "! Patzer !", 'm': "Misserfolg", '–': "kein Erfolg", 'B': "beinahe Erfolg", 'E': "einfacher Erfolg", 'G': "guter Erfolg", 'S': "sehr guter Erfolg", 'K': "kritischer Erfolg"}
export const successTiers = {miss: 0, normal: 1, critical: 4}
export const impactHue = {hurt: 0, harm: 28, nerf: 56, heal: 120, save: 160, buff: 200, envm: 240, move: 280, chrg: 320}

export function calc_activityColor(action) {
	// determine color of activity box (and card)
	const actionData = (typeof action === 'string') ? protoActions[action] : action
	if (actionData.kind) {
		const hue = (actionData.kind) ? impactHue[actionData.kind] : 210
		let sat = 100, lum = 50
		if (actionData.tier > 0) { // is power a fight-only power?
			lum = Math.round(85 - actionData.exertion * 1.5)
			sat = Math.round(70 + Math.min(Math.abs(55 - lum), 30))
		} else if (!(actionData.kind))
			sat = 0
		return `hsl(${hue}, ${sat}%, ${lum}%)`
	} else
		return 'lightgrey'
	/* return `hsl(${hue},${sat}%,${Math.round(lum / 3)}%)`*/
}

export function calc_defaultCS(charName, individ = false) {
    let cs = charName.replace("-", " ").split(" ").map(part => part.charAt(0).toLowerCase()).filter(letter => letter !== letter.toUpperCase()).join("")
	if (individ)  cs = cs.toUpperCase()
    let i = 97
	const usedCallsigns = user.characters.values().filter(char => char.ADVT === view.adventure.ID).map(char => char.CS).toArray()
    while (usedCallsigns.includes(cs)) {
		const suffix = String.fromCharCode(i)
        cs = ((cs.length < 3) ? cs : cs.slice(0, 2) ) + ((individ) ? suffix.toUpperCase() : suffix)
        i += 1
    }
	return cs
}

export function compose_outcome(insight) {
	let outcome = ""
	if (insight.roll) {
		// const reStr =
		// reStr = "".join(eff.name[0] for eff in evalEffects) if evalEffects else ""  # no roll eval effects if only 1 eval effect
		// insi.rolled = f"[{','.join(f'{r:02d}' for r in self.rolls[:2] if r)}]{reStr} = {roll}" if isinstance(insi, Inflict) and not insi.repeat else f"[{roll}]"
	}
	const tier = max(0, min(6, bisect(list_skills(globalParams['successTiers'].values()), insi.force) - 1))  // (0=miss), 1=normal ... 4=crit
	const successTxt = `'${list_skills(globalParams['successTiers'].keys())[tier]}'`
	outcome += ` → ${successTxt}`
	if (protoActions[insight.action]?.TYPE === 'Ability')
		// self.result = list(globalParams['successText'].values())[tier]
		outcome += ""
}



// ToDo: use library (https://github.com/jquery/jquery-color  or  https://github.com/bgrins/TinyColor)
const RegExs = {paranthesis: new RegExp("\\(.*?\\)", 'g'),}  // finds paranthesis (round brackets)

export const fieldLabels = {
	chapter: "Kapitel", section: "Abschnitt", topic: "Thema",
	archetype: "Archetyp", emphasis: "Ausrichtung", provenance: "Herkunft",
	name: "Name", adventure: "Abenteuer", campaigne: "Kampagne", fellowship: "Gruppe", number: "Nummer", whereabout: "Aufenthaltsort",
	season: "Jahreszeit", start: "Spielzeit", region: "Region", places: "Orte", teaser: "Einleitung",
	realtime: "Realzeit", summary: "Zusammenfassung", synopsis: "Kurzfassung",
	newSection: "+", site: "Ort", notes: "Notizen",
	chance: "MWW",
	level: "Stufe", combat: "KG", magic: "MG", vital: "LP", focus: "FP", size: "Größe", role: "Rolle",
	callsign: "Kürzel", rank: "Rang", ranks: "Ränge", affil: "Zugeh.", owner: "Eigentümer", condition: "Zustand",
	race: "Volk", subgroup: "Untergruppe", vocation: "Beruf", origin: "Herkunft", descript: "Beschreibung", affiliation: "Zugehörigkeit",
	face: "Angesicht", physique: "Figur", age: "Alter", height: "Größe", weight: "Gewicht",
	domain: "Spezialisierung", grade: "Grad", skill: "Fertigkeit", scale: "Skala", visib: "Sicht",
	weapon: "Waffe", weapType: "W-Art", secondary: "Zweitw.", spares: "weitere",
	armor: "Rüstung", burden: "R-Behind.",
	powers: "Spezial-Kräfte (mit Komma aufgezählt)",
	col: "Spalte", row: "Zeile", layer: "Ebene", map: "Karte",
	STR: "Stärke", CON: "Konstitution", AGL: "Beweglichkeit", DEX: "Fingergeschick", RFL: "Reflexe",
    INT: "Intuition", EMP: "Empathie", LOG: "Logik / Ratio", MEM: "Gedächtnis", CHA: "Ausstrahlung", WIL: "Willenskraft",
	gained: "Gesamt", combatXP: "Kampf", magicXP: "Magie", skillsXP: "Fähigk.",
	gearitem: "Gegenstand", outfit: "Ausrüstung", perks: "Boni in-App", category: "Kategorie", value: "Wert",
	mainhand: "Haupth.", sidehand: "Nebenhand", corearmor: "Rüstung", missile: "Geschoss eingelegt",
	gold: "Goldst.", silver: "Silberm.", delta: "Änderung", deltaSC: "Silberm.",
	head: "Kopf", shoulders: "Schultern", torso: "Torso",  arms: "Arme", legs: "Beine", hands: "Hände", feet: "Füße", waist: "Hüfte",
	neck: "Hals", ears: "Ohren", wrists: "Handgelenk", finger_1: "rechte Hand", finger_2: "linke Hand",
	hero: "Held", combatRole: "Rolle im Kampf", socialRole: "Rolle bei Interaktionen", environRole: "Präferierte Umgebung",
	earned: "Erhaltene EP", expended: "Verbrauchte EP", usable: "Vergebbare EP",
	primaries: "Primäre Fertigkeiten", secondaries: "Sekundäre Fertigkeiten", domains: "Spezialisierungen / Magiegebiete",
}

/** equipment types (key = abbreviation, aliases = values of the item type field) **/
export const gearTypes = {
	W: {label: "Waffen", name: "Waffe", icon: 'skull', aliases: ['weapon', 'waepon']},
	A: {label: "Rüstung", name: "Rüstung", icon: 'chess-rook', aliases: ['armor']},
	J: {label: "Schmuck", name: "Schmuck", icon: 'star', aliases: ['jewelry']},
	V: {label: "Wertsachen", name: "Wertgegenstand", icon: 'coins', aliases: ['valuable', 'gem', 'coin']},
	T: {label: "Werkzeug", name: "Werkzeug", icon: 'magnet', aliases: ['tool']},
	C: {label: "Verbrauch", name: "Verbrauchsgegenstand", icon: 'leaf', aliases: ['consumable', 'consumables']},
	G: {label: "Kleidung", name: "Kleidung", icon: 'scissors', aliases: ['garment']},
	O: {label: "Sonstiges", name: "Hilfsmittel", icon: 'compass', aliases: ['other', 'accessoir', 'accessoirs', 'equip']},
}

/** abbreviation of the equipment type of an item (unknown types count as other accessoir) **/
export function gear_type(item) {
	const type = item?.type ?? ""
	if (type in gearTypes)  return type
	return Object.keys(gearTypes).find(key => gearTypes[key].aliases.includes(type.toLowerCase())) ?? 'O'
}

/** formats an amount of silver as "1 GS 20 SM" (1 gold = 100 silver) **/
export function money_label(silver) {
	const gold = Math.floor(Math.abs(silver) / 100), rest = Math.abs(silver) % 100
	const sign = (silver < 0) ? "− " : ""
	if (gold && rest)  return `${sign}${gold} GS ${rest} SM`
	return (gold) ? `${sign}${gold} GS` : `${sign}${rest} SM`
}

export const storageCats = {
	'onperson': "Direkt am Körper getragen (= immer dabei)",
	'purse':    "Geldsäckchen (direkt am Körper)",
	'weapons':  "Waffen (möglichst immer in Reichweite)",
	'armor':    "Rüstungsteile (werden nur zum Schlafen ausgezogen)",
	'satchel':  "Umhängetasche (befindet sich immer in der Nähe)",
	'backpack': "Rucksack (normalerweise auf Pferd, bei Wanderungen am Rücken)",
	'garments': "Kleidung (normalerweise im Kleidersack am Pferd)",
	'mount':    "am Reittier befestigt",
	'pannier':  "Satteltaschen (normalerweise auf dem Pferd)",
	'storage':  "eingelagert (in Minas Tirith oder Starelien)",
	'other':    "anderer Ort (im Kommentar spezifizieren)"}


export const fieldHints = {
	pro: "Grundwert der zugrundeliegenden Fertigkeit", mod: "automatische Boni oder Mali auf das Manöver",
	con: "Grundwert der abwehrenden Fertigkeit des Opfers", bon: "individueller Bonus/Malus des Spielleiters",
	chance: "Mindest-Würfelwert für einen einfachen Erfolg der Aktion"}


export const noPersona = {
	ID: "", char: "", callsign: "", name: "", level: "", KG: null, SG: null, MG: null, LP: null, TYPE: "noCharacter",
	ranks: null, owner: "", alias: null, position: {col: -1, row: -1}, size: 1,
	percept: {}, hide: {total: 0}, awareness: {total: 0}, detecteds: [], lastseens: {},
	activity: null, concurrent: null, prepared: {action: "", aim: ""}, actionGroups: [],
	affects: {}, gearitems: [], equipments: {},
	life: 0, vital: 1, exhaustion: 0, focus: 1,
	descript: {} }

export const noActivity = {
	ID: 0, type: null, action: "", aim: "", dur: "", begin: 0, end: "x:xx", descript: "", rolled: "",
	diffclt: "", success: "", revision: "", repeat: "", multiple: "", amends: [], incidents: [], state: "" , chance: "", outcome: "",
	details: {}, aiming: {}}

export const noAction = {
	name: "", aiming: "", descript: ""
}

export const noPosition = {col: null, row: null, map: null, layer: ""}

export const noWeapon = {
	ID: "", base: "", offmod: 0, defmod: 0, rngmod: 0, damage: 0, attdur: 12
}

export const defaultVisibility = 20     // number of field for normal visibility
export const fieldResolution = 78     // size of one field in pixel
export const tokenResolution = 74       // size of one token in pixel
export const openEnd = 9999



const langMaps = {
	adventure:  {"Name": 'name', "Gruppe": 'fellowship', "Nummer": 'number', "Stufe": 'level', "Meister": 'master'},
	scene:      {"Nr": 'scene', "Szene": 'scene', "Name": 'name', "Modus": 'mode', "Grad": 'level', "Feinde": 'foes',
                 "Karten": 'maps', "Karte": 'mapfile', "Größe": 'size', "Sicht": 'visrange', "Faktor": 'scaling', "Umgebung": 'environment'},
	character:  {"Name": 'name', "Stufe": 'level', "Vorlage": 'name', "Größe": 'size',
                 "Volk": 'race', "Beruf": 'profession',  "Klasse": 'class', "Beschr": 'description', "Team": 'team',
                 "Eigen": 'traits', "Fähigk": 'skills', "Kräfte": 'powers', "Gebiete": 'domains', "Zugeh": 'affiliation',
                 "Kampf": 'combat', "Waffen": 'weapons', "Panzer": 'armor', "Rüstung": 'armor',
                 "Veteran": 'veteran', "Elite": 'elite', "Magie": 'magic', "Ränge": 'ranks'},
	chars:      {"ID": 'ID', "Name": 'name', "Stufe": 'level', "Ränge": 'ranks', "Beschreibung": 'description',
                 "Spezialisierungen": 'domains', "Kampf": 'combat', "Magie": 'magic', "Fertigkeiten": 'skills',
                 "Waffen": 'weapons', "Rüstung": 'armor', "Besonderheiten": 'other'},
	combat:     {"Kampfgeschick": 'cmb', "Schussgeschick": 'rng', "Offensivgeschick": 'off', "Defensivgeschick": 'def', "Zähigkeit": 'tgh'},
	magic:      {"Magiegeschick": 'mag', "Willenskraft": 'wil', "Konzentration": 'con'},
	affiliation:{"Freund": 'friend', "Gefährte": 'fellow', "Neutral": 'neutral', "Feind": 'enemy'},
	descript:   {"Größe [cm]": 'height', "Gewicht [kg]": 'weight', "Beruf": 'profession', "Volk": 'race', "Herkunft": 'origin', "Aussehen": 'apperance', "Figur": 'physique'}
}

export function bonusToString(bonus) {
	bonus = Math.round(bonus)
	return (bonus < 0) ? `– ${-bonus}` : (bonus > 0) ? `+ ${bonus}` : "± 0"}

export const signed = v => (v > 0) ? `+${v}` : (v < 0) ? `–${-v}` : "0"

export function perksToString(perks) {
    if (!perks || isEmpty(perks))  return "–"
	const perkStr = Object.entries(perks)
		.map(([key, val]) => `${key} ${(typeof val === 'number' || val > 0) ? bonusToString(val) : val}`)
		.join(", ")
	return perkStr
	}


const aggrFactor = (val) => array.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
export const sum_attrib = (arr, attr) => arr.map(elem => elem[attr]).reduce((accum, value) => accum + value, 0)
